<template>
    <!-- 找回密码页面组件 -->
    <div class="firstlogin-pack">
        <!-- header 部分 -->
        <portal-header :isShowUser='false'></portal-header>
        <div class="form-pack">
            <h3>{{$t('首次登录，请重置您的密码')}}</h3>
            <Form ref="form"
                  label-position="right"
                  :model="formData"
                  :rules="validates"
                  :label-width="175"
                  @keydown.enter="submit()"
                  class="form">
                <FormItem :label="$t('初始密码') + ':'"
                          prop="initialPassword">
                    <Input v-model="formData.initialPassword"
                           @copy.native.capture.prevent="handleCopy"
                           @cut.native.capture.prevent="handleCopy"
                           type="password"></Input>
                </FormItem>
                <FormItem :label="$t('新密码') + ':'"
                          prop="password">
                    <Input v-model="formData.password"
                           autocomplete="new-password"
                           @copy.native.capture.prevent="handleCopy"
                           @cut.native.capture.prevent="handleCopy"
                           type="password"></Input>
                    <Poptip trigger="hover"
                            :title="$t('密码策略')"
                            word-wrap
                            :transfer="true"
                            style="position: absolute; margin-left: 5px;">
                        <i class="icon-prompt-1-o"
                           style="color:#2d8cf0"></i>
                        <div slot="content"
                             class="poptip-pack"
                             style="width: 300px;">
                            <ul>
                                <li>{{$t('密码长度')}}：{{passwordInf.minLength}}-32</li>
                                <li>{{$t('最少相异字符数')}}：{{passwordInf.charactorLimit||'无'}}</li>
                                <li>{{$t('常用密码剔除')}}：{{passwordInf.ruleOuts||'无'}}</li>
                                <li>{{$t('密码包含规则')}}：{{passwordInf.charactorTypes||'无'}}</li>
                            </ul>
                        </div>
                    </Poptip>
                </FormItem>
                <FormItem :label="$t('确认新密码') + ':'"
                          prop="checkPassword">
                    <Input v-model="formData.checkPassword"
                           @copy.native.capture.prevent="handleCopy"
                           @cut.native.capture.prevent="handleCopy"
                           type="password"></Input>
                </FormItem>
                <FormItem :label="$t('验证手机') + ':'">
                    <Input :value="mobile"
                           disabled></Input>
                </FormItem>
                <FormItem :label="$t('验证码') + ':'"
                          prop="code">
                    <div style="display: flex">
                        <Input v-model="formData.code"
                               type="text"></Input>
                        <Button class="code-btn"
                                @click="getSmsCode"
                                :disabled="smsDisabled || !mobile"
                                :style="smsBtnStyle">{{smsDisabled ? `${smsTime}s后重新发送` : '获取验证码'}}</Button>
                    </div>
                </FormItem>
                <FormItem>
                    <div style="display: flex; margin-top: 25px;">
                        <!-- <Button @click="$router.go(-1)"
                                style="min-width: 70px; margin-right: 8px;">{{$t('取消')}}</Button> -->
                        <Button type="primary"
                                long
                                :loading="loading"
                                @click="submit('formData')">
                            {{$t('重置密码')}}
                        </Button>
                    </div>
                </FormItem>
            </Form>
        </div>
        <div class="footer">
            <p> <span>{{companyname}}</span>&nbsp;&nbsp;<span>{{copyright}}</span></p>
        </div>
    </div>
</template>
<script>
import portalHeader from '@c/portal/header'
import API from '@/service/api.js'
import locale from '@/locale/locale'
import iviewI18n from '@/locale/iview_i18n.js'
import { mapState } from 'vuex'

export default {
    name: 'firstlogin',
    components: {
        portalHeader
    },
    data () {
        return {
            companyname: null,
            copyright: null,
            syslogo: this.$store.state.app.appConfig.sysLogo,
            formData: {},
            passwordInf: {},
            smsTime: 60,
            loading: false,
            validates: {
                initialPassword: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            // this.$refs.form.validateField('password')
                            callback()
                        }
                    }
                ],
                password: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value === this.formData.initialPassword) {
                                callback(new Error(this.$i18n.t('新密码不能和旧密码相同')))
                            } else {
                                this.axios.get(this.urlFormat(API.ACCESS_PASSWRD_POLICY_VALID, false), { params: { password: this.$encrypt(value, true) } }).then(res => {
                                    res ? callback() : callback(this.$t('请按照右侧提示中的规则设置密码'))
                                })
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                checkPassword: [
                    {
                        required: true,
                        message: this.$i18n.t('该字段不能为空'),
                        trigger: 'blur'
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value !== this.formData.password) {
                                callback(new Error(this.$i18n.t('密码不一致')))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                code: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    {
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (value.length > 6) {
                                callback(this.$i18n.t('仅支持6位验证码'))
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            },
            smsDisabled: false
        }
    },
    created () {
        this.getRule()
        this.getPortalOem()
    },
    computed: {
        ...mapState({
            sysLogo: state => state.app.appConfig.sysLogo
        }),
        smsBtnStyle () {
            return {
                color: this.smsDisabled ? '#999' : '#515A6E',
                background: this.smsDisabled ? '#fff' : '#f8f8f9'
            }
        },
        appContactNumber () { // 系统联系号码
            return this.$store.state.app.appConfig.appContactNumber
        },
        appVersion () { // 系统版本
            return this.$store.state.app.appConfig.version
        },
        language () {
            return this.$store.state.app.appConfig.language
        },
        mobile () {
            return this.$store.state.user.currentUser.info.mobile
        }
    },
    methods: {
        getPortalOem () {
            this.axios.get(this.urlFormat(API.GET_PORTAL_OEM, true), {
                headers: {
                    noAuth: true
                }
            }).then(res => {
                this.companyname = 'Copyright ©' + res.companyName
                this.copyright = res.preparedNumber || ''
            })
        },
        getRule () {
            this.axios.get(this.urlFormat(API.ACCESS_PASSWORD_CONFIG, false), { params: { type: 'charactorType' } }).then(res => {
                const names = {}
                for (const i in res.rules) {
                    const rule = res.rules[i]
                    names[rule.key] = rule.desc
                }
                this.axios.get(this.urlFormat(API.ACCESS_PASSWORD_POLICY, false)).then(res => {
                    this.passwordInf = {
                        minLength: res.minLength,
                        charactorTypes: res.charactorType.map(t => names[t]).join('、'),
                        charactorLimit: res.charactorLimit,
                        ruleOuts: res.ruleOut.join('、')
                    }
                })
            })
        },
        getSmsCode () {
            const vm = this
            if (this.mobile) {
                this.axios.get(this.urlFormat(API.GET_SEND_SMS_CODE, true), {
                    params: {
                        phone: this.mobile,
                        nm: '1',
                        captcha: 1,
                        t: 1
                    },
                    headers: {
                        noAuth: true,
                        showMsg: false
                    }
                }).then((res) => {
                    if (res.status) {
                        this.smsDisabled = true
                        this.codeTimer = setInterval(function () {
                            if (vm.smsTime <= 1) {
                                vm.smsTime = 60
                                vm.smsDisabled = false
                                clearInterval(vm.codeTimer)
                            } else {
                                vm.smsTime--
                            }
                        }, 1000)
                    } else {
                        this.$Message.error(this.$t(res.message))
                    }
                })
            }
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    // this.changeLoading()
                    return
                }
                const { code, password, initialPassword } = this.formData
                const params = {
                    phone: this.mobile,
                    code: code,
                    password: this.$encrypt(password, true),
                    initialPassword: this.$encrypt(initialPassword, true)
                }
                this.loading = true
                this.axios.post(this.urlFormat(API.USER_FIRSTLOGIN, true), params).then(res => {
                    this.loading = false
                    if (res.status) {
                        setTimeout(() => {
                            this.$logout()
                        }, 1000)
                    }
                }).catch(e => {
                    this.loading = false
                })
            })
        },
        goLogin () {
            this.$login()
            // this.$router.push({ path: '/login' })
        },
        openUrl () {
            this.$router.push({ path: '/' })
        },
        handleLanguage (val) {
            localStorage.setItem('lang', val)
            this.$store.commit('setOtherConfig', { language: val })
            const messages = Object.assign(locale[val], iviewI18n[val])
            // 设置数据
            this.$i18n.setLocaleMessage(val, messages)
            // 切换语言
            this.$i18n.locale = val
        },
        handleCopy () {
            // 不允许复制
            return false
        }
    }
}
</script>
<style lang="less" scoped>
.firstlogin-pack {
    width: 100%;
    height: 100%;
    background-image: url(../assets/images/console/retrievePsdBg.png);
    background-size: cover;
    .form-pack {
        width: 600px;
        min-height: 430px;
        background-color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
        h3 {
            height: 70px;
            line-height: 70px;
            text-align: center;
            font-size: 20px;
            border-bottom: 1px dashed #e9e9e9;
        }
        .form {
            padding: 38px 120px 20px 0;
        }
    }

    .header {
        margin: 0 auto;
        background: #2a303c;
        height: 46px;
        .header-div {
            width: 100%;
            height: 46px;
            line-height: 46px;
            padding: 0 30px;
            margin: 0 auto;
            color: white;
            img {
                width: 160px;
                margin: 0;
                vertical-align: middle;
                cursor: pointer;
            }
            .dropdown {
                float: right;
                color: #ffffff;
                .i18n-area {
                    float: right;
                    font-size: 14px;
                    cursor: pointer;
                    color: #ddd;
                }
                .support {
                    float: right;
                    font-size: 14px;
                    cursor: pointer;
                    color: #ddd;
                }
                .support:hover {
                    color: #57a3f3;
                }
            }
        }
    }
}
</style>

<style lang="less">
.firstlogin-pack {
    .form-pack {
        .ivu-form-item {
            margin-bottom: 13px;
            .ivu-input-disabled {
                background-color: transparent;
                color: #515a6e;
            }
            .ivu-form-item-error-tip {
                padding-top: 1px;
            }
        }
    }
    .footer {
        position: absolute;
        bottom: 0px;
        width: 100%;
        line-height: 20px;
        font-size: 12px;
        color: #808080;
        text-align: center;
        padding: 30px 0;
        width: 1170px;
        margin-left: -585px;
        border-top: 1px solid #e3e3e3;
        left: 50%;
    }
}
</style>
